import React, { Component } from "react";

class BessSlider extends Component {
  render() {
    let publicUrl = process.env.PUBLIC_URL + "/";

    return (
      <div className="ltn__img-slider-area mb-20">
        <div className="container-fluid">
          <div className="row ltn__image-slider-5-active slick-arrow-1 slick-arrow-1-inner ltn__no-gutter-all">
            <div className="col-lg-12">
              <div className="ltn__img-slide-item-4">
                <img
                  src={publicUrl + "assets/img/img-slide/bess-banner.png"}
                  alt="ATP 105kWh BESS - Industrial Power Redefined"
                />
              </div>
            </div>
            <div className="col-lg-12">
              <div className="ltn__img-slide-item-4">
                <img
                  src={publicUrl + "assets/img/img-slide/bess-banner-2.jpeg"}
                  alt="Smart Energy Solution"
                />
              </div>
            </div>
            <div className="col-lg-12">
              <div className="ltn__img-slide-item-4">
                <img
                  src={publicUrl + "assets/img/img-slide/bess-banner-3.jpeg"}
                  alt="Solar Energy"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default BessSlider;
